export interface PublicBlogPost {
  id: string;
  title: string;
  author: string | null;
  cover_image: string | null;
  excerpt: string;
  content: string;
  created_at: string | null;
}

interface BlogRecord {
  id: string | number;
  title: string;
  author?: string | null;
  cover_image_url?: string | null;
  cover_image?: string | null;
  excerpt?: string | null;
  content?: string | null;
  created_at?: string | null;
  is_published: boolean;
}

const baseUrl = import.meta.env.DEV
  ? "/jambushrusti-api"
  : (
      import.meta.env.VITE_API_BASE_URL ||
      "https://api.jambushusti.universal-software.in/api"
    ).replace(/\/$/, "");
const endpoint = `${baseUrl}/jambushrusti/cms/blog-posts/`;

export async function fetchPublicBlogs(
  signal?: AbortSignal
): Promise<PublicBlogPost[]> {
  const posts: PublicBlogPost[] = [];
  let page = 1;
  let hasNext = true;

  while (hasNext) {
    const response = await fetch(`${endpoint}?page=${page}`, {
      signal,
      headers: {
        "X-Tenant-ID":
          import.meta.env.VITE_X_TENANTID ||
          "6cf833d7-bf6f-4688-9136-5674d8053b85",
      },
    });
    if (!response.ok) {
      throw new Error("Unable to load blog posts. Please try again.");
    }
    const payload = await response.json();
    const data = payload.data ?? payload;
    const rows: BlogRecord[] = Array.isArray(data) ? data : data.results;
    if (!Array.isArray(rows)) {
      throw new Error("The blog response could not be read.");
    }

    for (const post of rows) {
      if (post.is_published === true) {
        posts.push({
          id: String(post.id),
          title: post.title || "Untitled post",
          author: post.author || null,
          cover_image: post.cover_image || post.cover_image_url || null,
          excerpt: post.excerpt || "",
          content: post.content || "",
          created_at: post.created_at || null,
        });
      }
    }
    hasNext = Boolean(data.links?.next ?? data.next);
    page += 1;
  }
  return posts;
}
